import ProductInlineBanner from '@/components/PIBanner';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import Washing from '@/components/UI/svg/SaveElectric/Washing';
import TV from '@/components/UI/svg/solar-calculator/TV';
import { calcEnergyGeneration, calcEnergyStorage, getRecommand } from '@/constants/off-grid';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import AC from '@elem/compPage/DeltaProUltra/Launch/Detail/components/NA2/icons/AC';
import Cooker from '@elem/compPage/DeltaProUltra/Launch/Detail/components/NA2/icons/Cooker';
import AirConditioner from '@elem/SVGIcon/OffGrid/AirConditioner';
import Laptop from '@elem/SVGIcon/OffGrid/Laptop';
import Light from '@elem/SVGIcon/OffGrid/Light';
import MiniFridge from '@elem/SVGIcon/OffGrid/MiniFridge';
import ElectricGrill from '@elem/SVGIcon/PowerBackup/ElectricGrill';
import Microwave from '@elem/SVGIcon/PowerBackup/Microwave';
import Oven from '@elem/SVGIcon/VanlifeRoadtrips/Oven';
import EFPicture from 'elem/compCommon/EFPicture';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';
import Refrigerator from 'elem/SVGIcon/PowerBackup/Refrigerator';
import WaterPump from 'elem/SVGIcon/VanlifeRoadtrips/WaterPump';
import { cloneDeep } from 'lodash';
import css from './index.module.scss';

export default function E({ callBuy, updateSolar }: any) {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('offgrid');
    const { locale } = useRouter();
    const [flag, setFlag] = useState(false);
    const [flag2, setFlag2] = useState(false);
    const [flag3, setFlag3] = useState(false);

    const isNA = ['us', 'ca'].includes(locale);

    const SolarPanels: any[] = [
        {
            img: '',
            quantity: 1,
            isActive: true,
            energy: 400,
            id: '400w_rigid',
            title: t('secE_card_400w_rigid'),
            cartTitle: t('secE_cart_400w_rigid_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6841245925449',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40250363478089',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 4,
            isActive: false,
            energy: 100,
            id: '100w_rigid',
            title: t('secE_card_100w_rigid'),
            cartTitle: t('secE_cart_100w_rigid_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6808946278473',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40133459640393',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 4,
            isActive: false,
            energy: 400,
            id: '400w',
            title: '400W',
            cartTitle: 'EcoFlow 400W Portable Solar Panel',
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',
                    ca: '7287920001178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998021697609',
                    ca: '42092770263194',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 4,
            isActive: false,
            energy: 220,
            id: '220w',
            title: '220W',
            cartTitle: 'EcoFlow 220W Bifacial Portable Solar Panel',
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
    ];

    const iconMap: any = {
        Oven: <Oven />,
        Refrigerator: <Refrigerator />,
        WashingMachine: <Washing />,
        AC: <AC className="ac" />,
        Cooker: <Cooker className="ac" />,
        TV: <TV className="tv" />,
        WaterPump: <WaterPump />,
        Heater: <EFElectricHeater className="heater" />,
        CoffeeMaker: <CoffeeMaker />,
        Light: <Light />,
        Laptop: <Laptop />,
        MiniFridge: <MiniFridge />,
        AirConditioner: <AirConditioner />,
        ElectricGrill: <ElectricGrill />,
        Microwave: <Microwave />,
    };

    const [solarpanels, setSolarpanels] = useState(isNA ? SolarPanels : []);

    const cards: any = [
        {
            img: '',
            power: '6kWh | 7200W | 120V/240V',
            title: 'EcoFlow DELTA Pro Ultra',
            id: 'dpu',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-ultra-includes-extra-battery?variant=41963472289865',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7383152951369',
                    ca: '8006700236954',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41963472289865',
                    ca: '44244774650010',
                };
                return localMap[locale] || undefined;
            })(),
            descArr: [
                'Charge 0-100% in 1.5 hr',
                'Up to 5 days of essential power',
                'Auto-switchover, prolonged backup, and energy bill savings with EcoFlow Smart Home Panel 2',
            ],
            icons: [
                {
                    icon: 'WaterPump',
                    day: '2.4 hrs',
                    app: 'Well Pump 2000W',
                },
                {
                    icon: 'AC',
                    day: '2.7 hrs',
                    app: 'Air Conditioner 1800W',
                },
                {
                    icon: 'Oven',
                    day: '3 hrs',
                    app: 'Electric Oven 1650W',
                },
                {
                    icon: 'Heater',
                    day: '2.2 hrs',
                    app: 'Electric Heater 2200W',
                },
            ],
            children: locale === 'us' ? JSON.parse(JSON.stringify([solarpanels[0]])) : [],
        },
        {
            img: '',
            power: '4kWh | 4000W | 120V/240V',
            title: 'EcoFlow DELTA Pro 3',
            id: 'dp3',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7185477075017',
                    ca: '8231332380826',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                'Charge 0-100% in 1.5 hr with 2600W dual solar input',
                'Up to 3 days of essential power',
                'Auto-switchover, prolonged backup, and energy bill savings with EcoFlow Smart Home Panel 2',
            ],
            icons: [
                {
                    icon: 'WaterPump',
                    day: '1.6 hrs',
                    app: 'Well Pump 2000W',
                },
                {
                    icon: 'ElectricGrill',
                    day: '2.8 hrs',
                    app: 'Electric grill 1150W',
                },
                {
                    icon: 'AirConditioner',
                    day: '1.8 hrs',
                    app: 'Air Conditioner 1800W',
                },
                {
                    icon: 'WashingMachine',
                    day: '6.6 hrs',
                    app: 'Washer 500W',
                },
            ],
            children: locale === 'us' ? JSON.parse(JSON.stringify([solarpanels[0]])) : [],
        },
        {
            img: '',
            power: '3072Wh Capacity | 3600W Output | Smart Output Priority',
            title: 'EcoFlow DELTA 3 Ultra Plus',
            id: 'delta3ultraplus',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713',
                    ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62106740556147',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386143096905',
                    ca: '15164531016051',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54718705008713',
                    ca: '62106740556147',
                };
                return localMap[locale] || undefined;
            })(),
            descArr: [
                'Charge 0-100% in 1.5 hr',
                'Up to 5 days of essential power',
                'Auto-switchover, prolonged backup, and energy bill savings with EcoFlow Smart Home Panel 2',
            ],
            icons: [
                {
                    icon: 'WashingMachine',
                    day: '5.25hrs',
                    app: 'Washer 500W',
                },
                {
                    icon: 'CoffeeMaker',
                    day: '2.63hrs',
                    app: 'Coffee Maker 1000W',
                },
                {
                    icon: 'Microwave',
                    day: '2.02hrs',
                    app: 'Microwave 1300W',
                },
                {
                    icon: 'AirConditioner',
                    day: '1.46hrs',
                    app: 'Air Conditioner 1800W',
                },
            ],
            children: JSON.parse(JSON.stringify([solarpanels[2], solarpanels[3]])),
        },
        {
            img: '',
            power: '3072Wh Capacity | 3600W Output | 4 Charging Options',
            title: 'EcoFlow DELTA 3 Ultra',
            id: 'delta3ultra',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692148871241',
                    ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62060629590387',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386143096905',
                    ca: '15164531016051',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54692148871241',
                    ca: '62060629590387',
                };
                return localMap[locale] || undefined;
            })(),
            descArr: [
                'Charge 0-100% in 1.5 hr',
                'Up to 5 days of essential power',
                'Auto-switchover, prolonged backup, and energy bill savings with EcoFlow Smart Home Panel 2',
            ],
            icons: [
                {
                    icon: 'WashingMachine',
                    day: '5.25hrs',
                    app: 'Washer 500W',
                },
                {
                    icon: 'CoffeeMaker',
                    day: '2.63hrs',
                    app: 'Coffee Maker 1000W',
                },
                {
                    icon: 'Microwave',
                    day: '2.02hrs',
                    app: 'Microwave 1300W',
                },
                {
                    icon: 'AirConditioner',
                    day: '1.46hrs',
                    app: 'Air Conditioner 1800W',
                },
            ],
            children: JSON.parse(JSON.stringify([solarpanels[2], solarpanels[3]])),
        },
        {
            img: '',
            power: '3600Wh | 3600W | 120V',
            title: 'EcoFlow DELTA Pro',
            id: 'deltapro',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6585086836809',
                    ca: '6944959824026',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40516140138569',
                    ca: '43725958873242',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [],
            icons: [
                {
                    icon: 'WashingMachine',
                    day: '5.8 hrs',
                    app: 'Washer 500W',
                },
                {
                    icon: 'CoffeeMaker',
                    day: '2.9 hrs',
                    app: 'Coffee Maker 1000W',
                },
                {
                    icon: 'Microwave',
                    day: '2.2 hrs',
                    app: 'Microwave 1300W',
                },
                {
                    icon: 'AirConditioner',
                    day: '1.6 hrs',
                    app: 'Air Conditioner 1800W',
                },
            ],
            children: locale === 'us' ? JSON.parse(JSON.stringify([solarpanels[0]])) : [],
        },

        // {
        //     img: (() => {
        //         const map: any = {
        //             us: '/responsive/picture/common-products/delta2max+ts.png',
        //             ca: '/responsive/picture/common-products/delta2max.png',
        //         };
        //         return map[locale] || map.us;
        //     })(),
        //     power: t('secE_card3_power'),
        //     title: t('secE_card3_title'),
        //     id: 'delta2max',
        //     link_more: (() => {
        //         const localMap: any = {
        //             us: 'https://us.ecoflow.com/products/delta-2-max-transfer-switch?variant=40540277014601',
        //             ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=43592212775066',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     productId: (() => {
        //         const localMap: any = {
        //             us: '6906296205385',
        //             ca: '7825964400794',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     variantId: (() => {
        //         const localMap: any = {
        //             us: '40540277014601',
        //             ca: '43592212775066',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     descArr: ['secE_card3_desc1', 'secE_card3_desc2', 'secE_card3_desc3'],
        //     icons: [
        //         {
        //             icon: 'Light',
        //             day: t('secE_card3_icon1_day'),
        //             app: t('secE_card3_icon1_app'),
        //         },
        //         {
        //             icon: 'Laptop',
        //             day: t('secE_card3_icon2_day'),
        //             app: t('secE_card3_icon2_app'),
        //         },
        //         {
        //             icon: 'MiniFridge',
        //             day: t('secE_card3_icon3_day'),
        //             app: t('secE_card3_icon3_app'),
        //         },
        //         {
        //             icon: 'AirConditioner',
        //             day: t('secE_card3_icon4_day'),
        //             app: t('secE_card3_icon4_app'),
        //         },
        //     ],
        //     children: locale === 'us' ? JSON.parse(JSON.stringify(solarpanels)) : [],
        // },
    ];

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        console.log('---', flag, flag2, flag3);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: card.title,
                position: `Living Off The Grid Page_${card?.title}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            // window.open(card?.link_buy, '_blank');
            const target = card?.children?.find((item: any) => item?.isActive);
            const addCarts: any = [
                {
                    discountPrice: card?.discountPrice,
                    originalPrice: card?.originalPrice,
                    inventory: card?.inventory,
                    productId: card?.productId,
                    variantId: card?.variantId,
                    img: card?.img,
                    title: card?.title,
                    skuTitle: card?.skuTitle,
                },
            ];
            if (target?.quantity) {
                addCarts.push({
                    discountPrice: target?.discountPrice,
                    originalPrice: target?.originalPrice,
                    inventory: target?.inventory,
                    productId: target?.productId,
                    variantId: target?.variantId,
                    img: target?.img,
                    title: target?.cartTitle,
                    quantity: target?.quantity,
                    parentVariantId: target?.parentVariantId,
                    skuTitle: card?.skuTitle,
                });
            }
            callBuy(addCarts);
        }
    };

    const handleClick = (card: any, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        const activeIdx = tempChildren.findIndex((item: any) => item.isActive);
        tempChildren[activeIdx].isActive = false;
        tempChildren[m].isActive = true;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCount = (data: any, num: number, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        tempChildren[m].quantity = num;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCalclate = (card: any, list: any) => {
        card.energy = calcEnergyGeneration(list?.energy, list?.quantity, locale);
        card.storage = calcEnergyStorage(card?.id);
    };

    const setSolarStatu = (item: any, child?: any) => {
        if (!child) {
            child = item?.children?.find((list: any) => list?.isActive);
        }
        // 推荐状态：0 数量0-置灰 1：推荐 2:不推荐
        item.statu = child?.quantity === 0 ? 0 : child?.recommand?.includes(child?.quantity) ? 1 : 2;
    };

    const AddSubtractor = ({ data, callback, k, m }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventory ?? 1000;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 1);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1, k, m);
        };

        const addNumber = () => {
            if (number >= NUM_MAX) return false;
            setNumber(number + 1);
            callback(data, number + 1, k, m);
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX || !Boolean(Number(v))) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v), k, m);
        };

        return (
            <div className="addSubtractor">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    -
                </div>
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    +
                </div>
            </div>
        );
    };

    const getAsynItem = async (item: any) => {
        const { productId, variantId, link_more } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    if (link_more) {
                        handleCalclate(item, item.children[0]);
                    }
                    item.discountPrice = res?.data?.price;
                    item.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                    item.inventory = res?.data?.inventoryQuantity ?? undefined;
                    item.skuTitle = res?.data?.skuTitle || null;
                    // item.inventory = 100;
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    if (!item?.img && res?.data?.variantImg) {
                        item.img = res?.data?.variantImg;
                    }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        if (flag) {
            const tempSolarPanelsArr = JSON.parse(JSON.stringify(solarpanels));
            const solarPromises = tempSolarPanelsArr?.map((item: any) => getAsynItem(item));
            Promise.all(solarPromises)
                .then(() => {
                    setSolarpanels(tempSolarPanelsArr?.filter((list: any) => list?.inventory !== undefined));
                    setFlag2(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [flag]);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const promises = tempArr?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then(() => {
                setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
                setFlag(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (['us', 'ca'].includes(locale) && flag && flag2) {
            const tempArr = JSON.parse(JSON.stringify(cardLists));
            tempArr?.map((item: any, k: number) => {
                let children: any[];
                switch (k) {
                    case 0:
                        children = cloneDeep(solarpanels.filter((item: any) => ['400w_rigid', '400w'].includes(item.id)));
                        break;
                    case 1:
                        children = cloneDeep(solarpanels.filter((item: any) => ['400w', '220w'].includes(item.id)));
                        break;
                    case 2:
                        children = cloneDeep(solarpanels.filter((item: any) => ['400w', '220w'].includes(item.id)));
                        break;
                    case 3:
                        children = cloneDeep(solarpanels.filter((item: any) => ['400w', '220w'].includes(item.id)));
                        break;
                    case 4:
                        children = cloneDeep(solarpanels.filter((item: any) => ['400w', '220w'].includes(item.id)));
                        break;
                    default:
                        children = JSON.parse(JSON.stringify([solarpanels[3]]));
                }

                children.forEach((child) => {
                    child.isActive = false;
                });

                children[0] ? (children[0].isActive = true) : () => {};
                item.children = children;
                // item.children = JSON.parse(
                //     JSON.stringify(
                //         k === tempArr?.length - 1
                //             ? [solarpanels[3], solarpanels[2]]
                //             : k === 2
                //             ? [solarpanels[2]]
                //             : k === 0
                //             ?
                //             : [solarpanels[0]],
                //     ),
                // );
                item?.children?.map((child: any) => {
                    child.cartTitle = `${child?.cartTitle} (${item?.title})`;
                    child.parentVariantId = item?.variantId;
                    child.recommand = getRecommand(item?.id, String(child?.id));
                    if (child?.inventory < 0) {
                        child.quantity = 0;
                    } else if (child?.recommand?.length > 0 && child?.inventory < child?.recommand[0]) {
                        child.quantity = child?.inventory;
                    } else {
                        child.quantity = child?.recommand?.length > 0 ? child?.recommand[0] : 0;
                    }
                    // child.quantity = child.recommand[0];
                });
                setSolarStatu(item, item?.children[0]);
                handleCalclate(item, item?.children[0]);
            });
            setCardLists(tempArr);
            setFlag3(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solarpanels, flag, flag2]);

    useEffect(() => {
        const flag = solarpanels?.find((sp: any) => sp?.variantId === updateSolar?.variantId);
        if (updateSolar && flag) {
            const tempSolarArr = JSON.parse(JSON.stringify(solarpanels));
            const tempArr = JSON.parse(JSON.stringify(cardLists));
            const cardTargetIdx = tempArr?.findIndex((item: any) => item?.variantId === updateSolar?.parentVariantId);
            if (cardTargetIdx !== -1) {
                const solarTargetIdx = tempArr[cardTargetIdx]?.children.findIndex((item: any) => item?.variantId === updateSolar?.variantId);
                if (solarTargetIdx !== -1) {
                    tempArr[cardTargetIdx]['children'][solarTargetIdx]['quantity'] = updateSolar?.quantity;
                    setSolarStatu(tempArr[cardTargetIdx]);
                    handleCalclate(tempArr[cardTargetIdx], tempArr[cardTargetIdx]['children'][solarTargetIdx]);
                    setCardLists(tempArr);
                }
            }
        }
    }, [updateSolar]);

    return (
        <div id="off-grid-E" className={`off-grid-E off-grid-box inner ${css['off-grid-E']}`}>
            <h2 className="title">{t('secE_title')}</h2>
            <ul className="cards">
                {cardLists?.map((card: any, k: number) => (
                    <div key={k}>
                        <li className="card">
                            <div className="main-product">
                                <div className="card-img">
                                    <EFPicture src={card?.img} alt={card?.title} />
                                </div>
                                <div className="card-info">
                                    <p className="card-power">{card?.power}</p>
                                    <p className="card-title">{card?.title}</p>
                                    <ul className="card-descs">
                                        {card?.descArr?.map((desc: any, m: number) => (
                                            <li className="card-desc" key={`${k}_${m}`}>
                                                {t.rich(desc, {
                                                    a: (text: any) => (
                                                        <Link className="a" href={`https://${locale}.ecoflow.com/products/transfer-switch`} target="_blank">
                                                            {text}
                                                        </Link>
                                                    ),
                                                })}
                                            </li>
                                        ))}
                                    </ul>
                                    <ul className="card-icons">
                                        {card?.icons?.map((item: any, m: number) => (
                                            <li className="card-icon" key={`${k}_${m}`}>
                                                <span className="icon-svg">{iconMap[item?.icon]}</span>
                                                <div className="icon-info">
                                                    <p className="icon-day">{item?.day}</p>
                                                    <p className="icon-app">{item?.app}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            {isNA && (
                                <div className="sub-product">
                                    <p className="sub-title">{card?.id === 'delta3ultra' ? t('common_card_calculator_new') : t('common_card_calculator')}</p>
                                    <p className={`sub-calc ${card?.statu === 2 ? 'not-recommand' : card?.statu === 0 ? 'zero' : ''}`}>
                                        {card?.statu === 0
                                            ? t.rich('common_card_0', {
                                                  storagePower: card?.storage,
                                                  s: (text: string) => <span className="s">{text}</span>,
                                              })
                                            : card?.statu === 1
                                            ? t.rich('common_card_calculator_res', {
                                                  generatePower: card?.energy,
                                                  storagePower: card?.storage,
                                                  s: (text: string) => <span className="s">{text}</span>,
                                              })
                                            : t('common_card_no_recommand')}
                                    </p>
                                    <div className="solar-panel">
                                        <span className="sp-text">{t('secE_card_output')}</span>
                                        <ul className="sp-products">
                                            {card?.children?.map((list: any, m: number) => (
                                                <li
                                                    className={`output-list ${list?.isActive ? 'active' : ''}`}
                                                    key={`${k}_${m}`}
                                                    onClick={() => handleClick(card, k, m)}
                                                >
                                                    {list?.title}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="solar-panel">
                                        <span className="sp-text">{t('secE_card_quantity')}</span>
                                        <ul className="quantity-lists">
                                            {card?.children?.map((list: any, m: number) => (
                                                <li className={`quantity-list ${list?.isActive ? 'show' : 'hide'}`} key={`${k}_${m}`}>
                                                    <AddSubtractor data={list} callback={handleCount} k={k} m={m} />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                            <div className="card-btns">
                                {card?.link_buy && (
                                    <>
                                        {Number(card?.inventory) <= 0 ? (
                                            <button disabled className={`btn-buy card-btn disable`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                {t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )}
                                {card?.link_more && (
                                    <Link
                                        className="btn-more card-btn"
                                        href={`${card?.link_more}${
                                            String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                        }utm_source=scenario+page&utm_medium=Pillar`}
                                        target="_blank"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'select_product',
                                            list_name: t('secF_title'),
                                            product_name: card.title,
                                            button_name: t('common_card_more'),
                                        }}
                                    >
                                        {t('common_card_more')}
                                    </Link>
                                )}
                            </div>
                        </li>
                        {k === 0 && ['us', 'ca'].includes(locale) && <ProductInlineBanner style={{ width: '100%' }} />}
                    </div>
                ))}
            </ul>
        </div>
    );
}
